import { action } from "typesafe-actions";
import { IPaymentType } from "./paymentType";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { showMessage } from "../messages/messagesActions";

export const FETCH_PAYMENT_TYPE_PROGRESS = "FETCH_PAYMENT_TYPE_PROGRESS";
export const FETCH_PAYMENT_TYPE_SUCCESS = "FETCH_PAYMENT_TYPE_SUCCESS";
export const FETCH_PAYMENT_TYPE_FAILED = "FETCH_PAYMENT_TYPE_FAILED";

export const fetchPaymentTypeProgress = () =>
  action(FETCH_PAYMENT_TYPE_PROGRESS);
export const fetchPaymentTypeSuccess = (data: IPaymentType[]) =>
  action(FETCH_PAYMENT_TYPE_SUCCESS, {
    data,
  });
export const fetchPaymentTypeFailed = () => action(FETCH_PAYMENT_TYPE_FAILED);

export const fetchPaymnetTypeAsync =
  (
    // date: IDataTableV2DateState["dates"],
    organizationUUID: string,
    courseUUID?: string,
    batch?: string,
    acedmicYear?: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchPaymentTypeProgress());

      let url = "";
      if (organizationUUID) {
        url += `&organizations_uuid=${organizationUUID}`;
      }
      if (courseUUID) {
        url += `&courses_uuid=${courseUUID}`;
      }
      if (batch) {
        url += `&batch=${batch}`;
      }
      if (acedmicYear) {
        url += `&academic_year=${acedmicYear}`;
      }
      const res = await api.get(`report/get-paytype-total-fee-record?` + url);

      const data: IPaymentType[] = res.data.data;

      console.log("data==>",data);
      

      dispatch(fetchPaymentTypeSuccess(data));
    } catch (error: any) {
      dispatch(fetchPaymentTypeFailed());
      dispatch(
        showMessage({
          type: "error",
          message: error.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_PAYMENT_TYPE_STATE = "CLEAR_PAYMENT_TYPE_STATE";
export const CLEAR_PAYMENT_TYPE = "CLEAR_PAYMENT_TYPE";

export const clearPaymentTypeState = () => action(CLEAR_PAYMENT_TYPE_STATE);
export const clearPaymentType = () => action(CLEAR_PAYMENT_TYPE);
